import type React from 'react';
import { Suspense, useEffect, useState } from 'react';
import { lazyReactNaiveRetry } from '../../../constants/Lazy';
import Logo from './Logo';
import Search from './Search';

const UserMenu = lazyReactNaiveRetry(() => import('./UserMenu'));

interface NavbarProps {
  withSearch: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ withSearch }) => {
  const [onClient, setOnClient] = useState<boolean>(false);

  useEffect(() => {
    setOnClient(true);
  }, []);

  return (
    <div className="z-20 flex w-full flex-row items-center justify-center text-center">
      <div className="flex h-[80px] max-h-[80px] w-full max-w-screen-2xl border-b p-3">
        <div className="flex min-w-full flex-row items-center justify-center gap-3">
          <div className="flex flex-col items-start justify-start lg:w-1/4">
            <Logo size={22} showText alwaysBrand={!withSearch} />
          </div>
          {withSearch ? (
            <div className="flex grow flex-col items-center justify-center">
              <Search />
            </div>
          ) : (
            <div className="flex grow flex-col items-center justify-center">
              &nbsp;
            </div>
          )}
          {onClient && (
            <div className="flex flex-col items-end justify-end lg:w-1/4">
              <Suspense fallback={<div className="hidden">&nbsp;</div>}>
                <UserMenu />
              </Suspense>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
